import { postApi, putApi } from '../../../utils/api'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'

import { DOC_FLOW_RESULT_TABLE_CONFIG_URL } from './DocFlowResult.constants'

export function updateResultTableConfig(data) {
  return putApi({
    data,
    endpoint: `${DOC_FLOW_RESULT_TABLE_CONFIG_URL}config/`,
  })
}

export function resendDocFlowResultEpost(documentId, itemId) {
  return postApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/result-files/${itemId}/resend-epost/`,
  })
}
